import React from 'react'
import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from 'react-router-dom'
// import PropTypes from 'prop-types'

import { useAuthentication } from './hooks/useAuthentication'
import Loader from './components/Loader'

export interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>>
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { authState } = useAuthentication()

  if (authState.initializing) {
    return <Loader minHeight="100vh" />
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        (authState.authUser && authState.authUser.id !== '') ? <Component {...props} /> : <Redirect to={{
          pathname: '/',
          state: { from: props.location },
        }} />
      }
    />
  );
}

// PrivateRoute.propTypes = {
//   component: PropTypes.func.isRequired,
//   location: PropTypes.object
// }

export default PrivateRoute
